import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight, ChevronRight } from 'lucide-react';
import { IMAGES } from './retreatsData';

const COLLAGE = [IMAGES.sisterhood, IMAGES.southAfrica2022, IMAGES.costaRica2026, IMAGES.may2023];

export const RetreatsHero = ({ onPriorityList }) => (
  <section className="relative min-h-[92vh] flex items-center justify-center overflow-hidden" data-testid="retreats-hero">
    <div className="absolute inset-0 grid grid-cols-2 md:grid-cols-4">
      {COLLAGE.map((img) => (
        <div key={img} className="relative h-full">
          <img src={img} alt="Just Be retreat moment" className="w-full h-full object-cover" />
        </div>
      ))}
    </div>
    <div className="absolute inset-0 bg-gradient-to-t from-forest/70 via-forest/15 to-forest/10" />

    <div className="absolute top-6 left-6 z-20">
      <Link to="/" className="inline-flex items-center gap-2 text-white/90 hover:text-white transition-colors bg-black/30 px-4 py-2 rounded-full backdrop-blur-sm">
        <ArrowLeft className="h-4 w-4" />
        <span className="font-medium">Back to Home</span>
      </Link>
    </div>

    <div className="relative z-10 text-center px-6 max-w-4xl mx-auto py-24">
      <div className="bg-forest/60 backdrop-blur-md rounded-3xl px-6 sm:px-12 py-10 shadow-2xl">
      <p className="inline-block bg-terracotta/90 text-white font-semibold tracking-widest uppercase mb-6 text-xs sm:text-sm px-4 py-2 rounded-full">
        Just Be™ Retreats by Sister Diamonds
      </p>
      <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-[0_4px_8px_rgba(0,0,0,0.6)]">
        Come Somewhere You Don&apos;t Have to Be <span className="text-terracotta">the Strong One.</span>
      </h1>
      <p className="text-lg md:text-xl text-white/90 mb-4 max-w-2xl mx-auto leading-relaxed drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)]">
        Immersive experiences created for high-capacity women who are ready to step away from the demands of everyday life, reconnect with themselves, and be surrounded by women who understand what it means to carry a lot.
      </p>
      <p className="font-heading text-xl md:text-2xl text-terracotta italic mb-10 drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)]">
        Release. Restore. Reconnect. Just Be.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          onClick={() => document.getElementById('journey')?.scrollIntoView({ behavior: 'smooth' })}
          size="lg"
          className="bg-terracotta hover:bg-terracotta/90 text-white px-8 py-6 text-lg shadow-xl"
          data-testid="hero-explore-retreats-btn"
        >
          Explore Our Retreats <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
        <Button
          onClick={onPriorityList}
          variant="outline"
          size="lg"
          className="border-white text-white bg-white/10 hover:bg-white/20 px-8 py-6 text-lg shadow-xl backdrop-blur-sm"
          data-testid="hero-priority-list-btn"
        >
          Be First to Know What&apos;s Next
        </Button>
      </div>
      </div>
    </div>

    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce z-10">
      <ChevronRight className="h-8 w-8 text-white rotate-90" />
    </div>
  </section>
);
